import { Link } from "react-router";

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen">
      <section className="py-20 bg-[#F6F2EB]">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Privacy Policy</h1>
          <p className="text-muted-foreground">Last updated: April 23, 2026</p>
        </div>
      </section>

      <section className="py-12 bg-[#F6F2EB]">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold mb-4">1. Introduction</h2>
            <p className="text-muted-foreground mb-8">
              This Privacy Policy is issued by Paper Printing Services, the legal entity operating the Colour Club Printers brand. We are a premium packaging and printing company based in Faisalabad, Pakistan, serving global brands with FSC certified, ISO 9001 compliant, and Sedex registered operations. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="text-3xl font-bold mb-4">2. Information We Collect</h2>
            <p className="text-muted-foreground mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Name, email address, phone number, and company details</li>
              <li>Billing and shipping addresses</li>
              <li>Payment information (processed securely through third-party payment processors)</li>
              <li>Project specifications and design files</li>
              <li>Communications with our team</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">3. How We Use Your Information</h2>
            <p className="text-muted-foreground mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Process and fulfill your orders</li>
              <li>Communicate with you about your projects</li>
              <li>Provide customer support</li>
              <li>Send you marketing communications (with your consent)</li>
              <li>Improve our products and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">4. Information Sharing</h2>
            <p className="text-muted-foreground mb-8">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Service providers who assist in our operations</li>
              <li>Shipping and logistics partners</li>
              <li>Payment processors</li>
              <li>Legal authorities when required by law</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">5. Data Security</h2>
            <p className="text-muted-foreground mb-8">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission is completely secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-3xl font-bold mb-4">6. Your Rights</h2>
            <p className="text-muted-foreground mb-4">
              Depending on your location, you may have the following rights:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Access to your personal information</li>
              <li>Correction of inaccurate data</li>
              <li>Deletion of your personal information</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">7. Cookies and Tracking</h2>
            <p className="text-muted-foreground mb-8">
              We use cookies and similar tracking technologies to improve your experience on our website. You can control cookies through your browser settings. For more information, see our <Link to="/cookie-policy" className="text-accent hover:underline">Cookie Policy</Link>.
            </p>

            <h2 className="text-3xl font-bold mb-4">8. International Data Transfers</h2>
            <p className="text-muted-foreground mb-8">
              Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy.
            </p>

            <h2 className="text-3xl font-bold mb-4">9. Children's Privacy</h2>
            <p className="text-muted-foreground mb-8">
              Our services are not directed to individuals under 18 years of age. We do not knowingly collect personal information from children.
            </p>

            <h2 className="text-3xl font-bold mb-4">10. Changes to This Policy</h2>
            <p className="text-muted-foreground mb-8">
              We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-3xl font-bold mb-4">11. Contact Us</h2>
            <p className="text-muted-foreground mb-4">
              If you have questions about this Privacy Policy or our privacy practices, please contact us:
            </p>
            <div className="bg-white rounded-2xl p-6 mb-8 space-y-2 text-muted-foreground">
              <p>
                <strong>Email:</strong> info@colourclubprinters.com
              </p>
              <p>colourclubprinter@gmail.com</p>
              <p>
                <strong>Tel:</strong> +92-41-8750239
              </p>
              <p>
                <strong>Tel:</strong> +92-41-8850239
              </p>
              <p>
                <strong>Mobile:</strong> +92-300-8666239
              </p>
              <p>
                <strong>Address:</strong> Madina Market, Sugar Mor, Near PSO Pump, Sheikhupura Road, Nishatabad,
                Faisalabad, Pakistan
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
